import { render, staticRenderFns } from "./Manager.vue?vue&type=template&id=b72becd4&scoped=true"
import script from "./Manager.vue?vue&type=script&lang=js"
export * from "./Manager.vue?vue&type=script&lang=js"
import style0 from "./Manager.vue?vue&type=style&index=0&id=b72becd4&prod&lang=css"
import style1 from "./Manager.vue?vue&type=style&index=1&id=b72becd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b72becd4",
  null
  
)

export default component.exports